import { render, staticRenderFns } from "./RateOfDecreaseDialog.vue?vue&type=template&id=1bb73751&scoped=true"
import script from "./RateOfDecreaseDialog.vue?vue&type=script&lang=ts"
export * from "./RateOfDecreaseDialog.vue?vue&type=script&lang=ts"
import style0 from "./RateOfDecreaseDialog.vue?vue&type=style&index=0&id=1bb73751&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb73751",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/engagement-form/rate-of-decrease-dialog.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsearch%2Fengagement-form%2FRateOfDecreaseDialog.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports